import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const LocationPage = styled.div`
  font-size: ${fromTheme('font_size')};
  font-family: ${fromTheme('font_face')};
  color: ${fromTheme('color_text')};
  line-height: ${fromTheme('font_line_height')};
  margin: 0 auto;
  padding: 0 ${fromTheme('spacing_large')} ${fromTheme('spacing_medium')}
    ${fromTheme('spacing_large')};
  background-color: ${fromTheme('color_background')};
  max-width: 1440px;

  * {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  gap: ${fromTheme('spacing_large')};
`;

export const SectionHeader = styled.h2`
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bolder')};
  font-family: ${fromTheme('font_face')};
  color: ${fromTheme('color_text')};
  line-height: ${fromTheme('font_line_height')};
  margin: 0 0 ${fromTheme('spacing_medium')};
`;

export const ContentSection = styled.section`
  padding-bottom: ${fromTheme('spacing_large')};
`;

export const SectionContainer = styled.section`
  border-bottom: ${fromTheme('border_width')} ${fromTheme('border_style')}
    ${fromTheme('color_border')};
  scroll-margin-top: 60px;
`;

export const ContentList = styled.div`
  > div {
    border: none;
    padding: 0;
    margin-bottom: 0;
  }
  h2 {
    font-size: ${fromTheme('font_size_heading_5')};
    font-family: ${fromTheme('font_face')};
    font-weight: ${fromTheme('font_weight_bolder')};
    color: ${fromTheme('color_text')};
    line-height: ${fromTheme('font_line_height')};
    margin-bottom: ${fromTheme('spacing_medium')};
  }

  && ul {
    margin: 0;
    list-style-position: outside;
    margin-left: 24px;
  }

  && li {
    list-style-type: initial;
    color: ${fromTheme('color_text')};
    margin-bottom: 0;
  }
`;

export const LocationNavContainer = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 900;
  background-color: ${fromTheme('color_background')};

  @media (max-width: 992px) {
    display: none;
  }

  // section nav: always draw a solid divider below the tabs, whatever the
  // theme's border_style
  & nav {
    padding-left: 0;
    outline: 0;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    border-bottom: ${fromTheme('border_width')} solid
      ${fromTheme('color_border')};
    border-radius: 0;
    align-items: flex-end;
  }

  & nav > a {
    background: none;
  }
`;

export const LocationGridContainer = styled('div')<{ showAside: boolean }>`
  @media screen {
    display: grid;
  }

  grid-template-columns: 1fr;
  gap: ${fromTheme('spacing_large')};

  @media screen and (min-width: ${fromTheme('screen_large')}) {
    grid-template-columns: ${(props) =>
      props.showAside ? '3fr minmax(325px, 1.25fr)' : '1fr'};
    gap: ${fromTheme('spacing_large')};
  }
`;

export const LocationInfoContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${fromTheme('spacing_large')};
`;
